// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qtktptvszldgtfurmwml.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF0a3RwdHZzemxkZ3RmdXJtd21sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxOTMxMTksImV4cCI6MjA1Nzc2OTExOX0.jfn953pfKfdT4qpJLcTJs2uX1KOSA8HXR4j0umLt82s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);